import Vue from "vue";
import Router from "vue-router";

import auth from "./auth";

import Home from "./views/home";
//import Home from "./components/SocialLogin.vue";
import ContactInfo from "./views/contact-info";
import AdminMain from "./views/admin-main";
import CreateUserAccount from "./views/create-user-account";
import EditUserAccount from "./views/edit-user-account";
import CreateAdminAccount from "./views/create-admin-account";
import ResubscribeAdminAccount from "./views/resubscribe-admin-account";
import InactiveSubscription from "./views/inactive-subscription";
import Directory from "./views/directory";
import SuccessPage from "./views/success-page";
import ResetPassword from "./components/reset-password.vue";
import NewPassword from "./components/new-password.vue";
import AccountCreated from "./components/account-created.vue";
import ChangePassword from "./components/change-password.vue";

import defaultLayout from "./layouts/side-nav-outer-toolbar";
import noHeaderLayout from "./layouts/no-header-layout";
import simpleLayout from "./layouts/single-card";
import simpleLayoutGray from "./layouts/single-card-gray";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/default',
      beforeEnter() {location.href = 'https://www.csl-us.com/'},
      name: "default",
      meta: { requiresAuth: false },
      components: {
        layout: defaultLayout,
        content: Home
      }
    },
    {
      path: "/home",
      name: "home",
      meta: { requiresAuth: false },
      components: {
        layout: defaultLayout,
        content: Home
      }
    },
    {
      path: "/success",
      name: "success-page",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayoutGray,
        content: SuccessPage
      },
      props: true,
    },
    {
      path: "/contact-info/:locationCode",
      name: "contact-info",
      meta: { requiresAuth: false },
      components: {
        layout: defaultLayout,
        content: ContactInfo
      },
    },
    {
      path: "/admin",
      name: "admin-main",
      meta: { requiresAuth: false },
      components: {
        layout: defaultLayout,
        content: AdminMain
      },
      props: true,
    },
    {
      path: "/directory",
      name: "directory",
      meta: { requiresAuth: false },
      components: {
        layout: noHeaderLayout,
        content: Directory
      },
    },
    {
      path: "/create-user-account",
      name: "create-user-account",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: CreateUserAccount
      }
    },  
    {
      path: "/edit-user-account",
      name: "edit-user-account",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: EditUserAccount
      }
    },  
    {
      path: "/create-admin-account",
      name: "create-admin-account",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: CreateAdminAccount
      }
    }, 
    {
      path: "/renew",
      name: "inactive-subscription",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: InactiveSubscription
      }
    }, 
    {
      path: "/resubscribe",
      name: "resubscribe-admin-account",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: ResubscribeAdminAccount
      }
    },      
    {
      path: "/login-form",
      name: "login-form",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        // route level code-splitting
        // this generates a separate chunk (login.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        content: () =>
          import(/* webpackChunkName: "login" */ "./views/login-form")
      }
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      name: "reset-password",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: ResetPassword
      },
      props: true,
    },  
    {
      path: "/newpass/:resetGuid",
      name: "new-password",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: NewPassword
      },
    },  
    {
      path: "/account-created",
      name: "account-created",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: AccountCreated
      }
    }, 
    {
      //path: "/changepass/:userId",
      path: "/changepass",
      name: "change-password",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: ChangePassword
      },
    },  
    {
      path: "*",
      redirect: "/home"
    }
    
  ]
});

//This is where we can check on things before navigating to a new page
//  For example, we check to see if a user is authenticated
router.beforeEach((to, from, next) => {

  //if (to.name === "login-form" && auth.authenticated()) {
  //  next({ name: "home" });
  //}

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.authenticated()) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
